import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo5/dos_documentos.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo5 } from "../../../routes/Module5";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo5/Actividad 3.mp3";

const Actividad3 = () => {
  const infoUnidad = modulo5.content[0];
  const infoAct = modulo5.content[0].activities[2];
  const crumbs = [
    {
      title: modulo5.title,
      url: "/" + modulo5.url,
    },
    {
      title:
        modulo5.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo5.content[0].activities[3].name}`,
    linkNext: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[3].path}`,
    titlePrev: `${modulo5.content[0].activities[1].name}`,
    linkPrev: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[1].path}`,
  };

  const metadata = {
    color: modulo5.color,
    title: `${modulo5.title} - ${infoAct.name}`,
    name: modulo5.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo5.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          Recién desde el año 2005, también los menores de edad tienen DNI. ¿En
          qué se diferencian el DNI de adultos y el de menores?
        </li>
      </ul>
      <img src={Imagen1} alt="Documentos" className="img-fluid img-80" />

      <GuiaDocente>
        <p>
          Lea las indicaciones. Ayude a encontrar las diferencias, por ejemplo,
          el color y el estado civil.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
